<template>
  <div class="calligraphy-website">
    <div class="hero-section">
      <h1 class="main-title">灵声墨韵</h1>
      <p class="subtitle">挥毫落纸听灵声，墨韵纵横字字清</p>
    </div>
    
    <div class="menu-container">
      <!-- 书法历史介绍 -->
      <div class="menu-section">
        <div class="section-icon">📜</div>
        <h2>书法历史介绍</h2>
        <p class="section-description">了解中国书法的发展历程，从甲骨文到现代书法的演变</p>
        <router-link to="/history" class="section-link">探索历史</router-link>
      </div>

      <!-- 经典书法作品 -->
      <div class="menu-section">
        <div class="section-icon">🖋️</div>
        <h2>经典书法作品</h2>
        <p class="section-description">欣赏历代书法名家的经典作品，感受不同书体的艺术魅力</p>
        <router-link to="/classic" class="section-link">欣赏作品</router-link>
      </div>

      <!-- 个人习作分享 -->
      <div class="menu-section">
        <div class="section-icon">✍️</div>
        <h2>个人习作分享</h2>
        <p class="section-description">分享个人书法练习作品，记录学习心得与成长历程</p>
        <router-link to="/personal" class="section-link">查看习作</router-link>
      </div>
    </div>
    
    <div class="feature-section">
      <h2 class="feature-title">书法艺术的魅力</h2>
      <div class="feature-cards">
        <div class="feature-card">
          <h3>历史传承</h3>
          <p>书法是中国传统文化的重要组成部分，承载着数千年的历史文化底蕴</p>
        </div>
        <div class="feature-card">
          <h3>艺术美学</h3>
          <p>不同书体展现出独特的艺术风格，体现了中国人特有的审美情趣</p>
        </div>
        <div class="feature-card">
          <h3>修身养性</h3>
          <p>练习书法可以培养专注力，陶冶情操，达到修身养性的目的</p>
        </div>
      </div>
    </div>

    <footer class="footer">
      <hr>
      <p> PoweredBy DavidXiao | Copyright © 2025 DavidXiao 保留所有权利 | <a href="https://beian.miit.gov.cn/" target="_blank">蜀ICP备2025123332号-1</a> | 
      <img src="@/assets/beian.png" alt="公安备案图标" style="vertical-align: middle; margin-right: 5px; height: 1em; width: auto;">
      <a href="https://beian.mps.gov.cn/#/query/webSearch?code=51010402001655" rel="noreferrer" target="_blank">川公网安备51010402001655号</a> </p>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld'
}
</script>

<style scoped>
.calligraphy-website {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.hero-section {
  text-align: center;
  padding: 80px 20px;
  background: linear-gradient(135deg, #f9f9f9, #f0f0f0);
  margin: -60px -20px 60px;
  position: relative;
  overflow: hidden;
}

.hero-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('../assets/images/lingsheng_bg.webp') center/contain no-repeat;
  opacity: 0.05;
  z-index: 0;
}

.main-title {
  font-size: 4em;
  color: #333;
  margin-bottom: 20px;
  font-family: 'SimSun', serif;
  position: relative;
  z-index: 1;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
}

.subtitle {
  font-size: 1.5em;
  color: #666;
  font-family: 'SimSun', serif;
  position: relative;
  z-index: 1;
}

.menu-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
  margin-bottom: 80px;
}

.menu-section {
  background: #fff;
  border-radius: 8px;
  padding: 40px 30px;
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  position: relative;
  overflow: hidden;
}

.menu-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #333, #999);
}

.menu-section:hover {
  transform: translateY(-10px);
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
}

.section-icon {
  font-size: 3em;
  margin-bottom: 20px;
  display: block;
}

.menu-section h2 {
  font-size: 1.5em;
  color: #333;
  margin-bottom: 15px;
  font-family: 'SimSun', serif;
}

.section-description {
  color: #666;
  line-height: 1.6;
  margin-bottom: 30px;
  font-size: 0.95em;
}

.section-link {
  display: inline-block;
  padding: 12px 30px;
  background: #333;
  color: #fff;
  text-decoration: none;
  border-radius: 4px;
  font-size: 0.9em;
  transition: background 0.3s ease;
  font-family: 'SimSun', serif;
}

.section-link:hover {
  background: #555;
}

.feature-section {
  background: #f9f9f9;
  padding: 60px 20px;
  margin: 0 -20px 60px;
  text-align: center;
}

.feature-title {
  font-size: 2em;
  color: #333;
  margin-bottom: 40px;
  font-family: 'SimSun', serif;
}

.feature-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.feature-card {
  background: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  text-align: left;
}

.feature-card h3 {
  font-size: 1.2em;
  color: #333;
  margin-bottom: 15px;
  font-family: 'SimSun', serif;
}

.feature-card p {
  color: #666;
  line-height: 1.6;
  font-size: 0.95em;
}

.footer {
  text-align: center;
  padding: 30px 20px;
  margin-top: 60px;
  border-top: 1px solid #e0e0e0;
}

.footer p {
  color: #666;
  font-size: 0.9em;
  line-height: 1.6;
}

.footer a {
  color: #666;
  text-decoration: none;
}

.footer a:hover {
  color: #333;
  text-decoration: underline;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .main-title {
    font-size: 2.5em;
  }
  
  .subtitle {
    font-size: 1.2em;
  }
  
  .menu-container {
    grid-template-columns: 1fr;
    gap: 30px;
  }
  
  .feature-cards {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .hero-section {
    padding: 60px 20px;
  }
  
  .menu-section {
    padding: 30px 20px;
  }
  
  .footer {
    padding: 20px 10px;
    margin-top: 40px;
  }
  
  .footer p {
    font-size: 0.8em;
  }
}
</style>
